module.exports = __webpack_public_path__ + "static/img/12bg_1.f6527eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_1.png
// module id = 629
// module chunks = 1